export const ADMIN_OUTCOMES = [
  { key: "uploaded", outcome: "UPLOADED", label: "Successful", color: "#4ade80" },
  { key: "cancelledTechnical", outcome: "CANCELLED_TECHNICAL", label: "Cancelled \u2014 technical", color: "#fbbf24" },
  { key: "cancelledNonTechnical", outcome: "CANCELLED_NON_TECHNICAL", label: "Cancelled \u2014 non-technical", color: "#a78bfa" },
  { key: "cancelledSystem", outcome: "CANCELLED_SYSTEM", label: "Cancelled \u2014 system", color: "#94a3b8" },
  { key: "failed", outcome: "FAILED", label: "Failed", color: "#f87171" },
];

export const getAdminOutcomeConfig = (outcome) =>
  ADMIN_OUTCOMES.find((item) => item.outcome === outcome) || null;

export const getAdminOutcomeConfigForStatus = (status, cancelReason) => {
  if (status === "CANCELLED") {
    if (cancelReason === "TECHNICAL") {
      return getAdminOutcomeConfig("CANCELLED_TECHNICAL");
    }
    if (cancelReason === "NON_TECHNICAL") {
      return getAdminOutcomeConfig("CANCELLED_NON_TECHNICAL");
    }
    return getAdminOutcomeConfig("CANCELLED_SYSTEM");
  }
  if (status === "FAILED") {
    return getAdminOutcomeConfig("FAILED");
  }
  return getAdminOutcomeConfig("UPLOADED");
};

// Display map for the raw UploadStatus enum, covering every value the backend can emit — the
// outcome config above only knows about terminal outcomes, which is not enough for a status
// history where every intermediate transition shows up. Kept in sync with UploadStatus.java;
// an unmapped value falls back to the raw enum name rather than rendering blank.
const UPLOAD_STATUS_DISPLAY = {
  PENDING_CHUNKS: { label: "Pending chunks", color: "#94a3b8" },
  CHUNK_UPLOAD_IN_PROGRESS: { label: "Uploading", color: "#60a5fa" },
  PAUSED: { label: "Paused", color: "#fbbf24" },
  CHUNK_UPLOAD_ASSEMBLING: { label: "Assembling", color: "#818cf8" },
  READY_TO_UPLOAD_TO_PROVIDER: { label: "Ready to provider", color: "#818cf8" },
  IN_PROGRESS_UPLOAD_TO_PROVIDER: { label: "Uploading to provider", color: "#60a5fa" },
  READY_FOR_CAT_DV: { label: "Ready for CatDV", color: "#818cf8" },
  CAT_DV_INGESTED: { label: "CatDV ingested", color: "#4ade80" },
  UPLOADED: { label: "Uploaded", color: "#4ade80" },
  EDIT_IN_PROGRESS: { label: "Edit in progress", color: "#60a5fa" },
  EDITED: { label: "Edited", color: "#4ade80" },
  TAGGING_IN_PROGRESS: { label: "Tagging in progress", color: "#60a5fa" },
  TAGGED: { label: "Tagged", color: "#4ade80" },
  PUBLISHED: { label: "Published", color: "#4ade80" },
  ON_HOLD: { label: "On hold", color: "#fbbf24" },
  REJECTED: { label: "Rejected", color: "#f87171" },
  CANCELLED: { label: "Cancelled", color: "#fbbf24" },
  FAILED: { label: "Failed", color: "#f87171" },
};

// Returns the chip tints alongside the label so callers don't each re-derive them. Safe to call
// `rgba` here even though it's declared below: this only runs at render time, well after module
// evaluation has initialised it.
export const getUploadStatusDisplay = (status) => {
  const config = UPLOAD_STATUS_DISPLAY[status] || {
    label: status || "Unknown",
    color: "#94a3b8",
  };

  return {
    ...config,
    background: rgba(config.color, 0.16),
    border: rgba(config.color, 0.36),
  };
};

const hexToRgb = (hex) => {
  if (!hex || typeof hex !== "string") return null;
  const normalized = hex.replace("#", "");
  if (normalized.length !== 6) return null;
  const value = parseInt(normalized, 16);
  if (Number.isNaN(value)) return null;
  return {
    r: (value >> 16) & 255,
    g: (value >> 8) & 255,
    b: value & 255,
  };
};

const rgba = (hex, alpha) => {
  const rgb = hexToRgb(hex);
  if (!rgb) return `rgba(255,255,255,${alpha})`;
  return `rgba(${rgb.r},${rgb.g},${rgb.b},${alpha})`;
};

export const getAdminOutcomeHeaderStyles = (status, cancelReason) => {
  const config = getAdminOutcomeConfigForStatus(status, cancelReason);
  const color = config?.color || "#94a3b8";
  return {
    outcome: config?.outcome || "CANCELLED_SYSTEM",
    color,
    border: rgba(color, 0.34),
    background: rgba(color, 0.12),
    backgroundHover: rgba(color, 0.18),
    dot: rgba(color, 0.95),
    text: "#f7fafa",
    secondaryText: "#f7fafaa6",
  };
};
